import { RouteObject, Navigate } from 'react-router-dom';
import FrontLayout from '../layout/Front';
import Portal from './pages/Portal';

import LazyWrapper from '@/common/LasyWrapper';
import React from 'react';
import examCenterRouter from './pages/examCenter/router';
import analysisRouter from './pages/examCenter/pages/analysis/router';
import modifyRouter from './pages/examCenter/pages/modifyScore/router';
import permissionRouter from './pages/permission/router';

// 懒加载
const SchoolMana = React.lazy(() => import('./pages/schoolMana/SchoolPortal'));
const SchoolIndex = React.lazy(() => import('./pages/schoolMana/SchoolIndex'));
const TemplateIndex = React.lazy(() => import('./pages/template/TemplateIndex'));
const AddTemplate = React.lazy(() => import('./pages/template/AddTemplate'));
const PersonnelMana = React.lazy(() => import('./pages/personnelMana/PersonnelPortal'));
const ImportExcel = React.lazy(() => import('../common/importExcel/ImportExcel'));
const ImportHistory = React.lazy(() => import('../common/importExcel/ImportHIstory'));
const ImportHistoryDetail = React.lazy(() => import('../common/importExcel/ImportHistoryDetail'));


// 教师单独的路由
const teacherRouter: RouteObject[] = [
  {
    path: ':school',
    element: <LazyWrapper><SchoolIndex></SchoolIndex></LazyWrapper>
  }
];
// 教育局人员路由
const eduRouter: RouteObject[] = [
  {
    path: 'school',
    element: <LazyWrapper><SchoolMana></SchoolMana></LazyWrapper>
  },
  {
    path: 'school/:school',
    element: <LazyWrapper><SchoolIndex></SchoolIndex></LazyWrapper>
  },
  {
    path: 'personnel',
    element: <LazyWrapper><PersonnelMana></PersonnelMana></LazyWrapper>
  },
  {
    path: 'template',
    element: <LazyWrapper><TemplateIndex></TemplateIndex></LazyWrapper>
  },
  {
    path: 'template/addTemplate',
    element: <LazyWrapper><AddTemplate></AddTemplate></LazyWrapper>
  },
  {
    path: 'template/editTemplate',
    element: <LazyWrapper><AddTemplate></AddTemplate></LazyWrapper>
  },
  // 导入教研室人员
  {
    path: 'personnel/importEduUser',
    element: <LazyWrapper><ImportExcel></ImportExcel></LazyWrapper>
  },
  // 导入教师 人员管理
  {
    path: 'personnel/importTeacherUser',
    element: <LazyWrapper><ImportExcel></ImportExcel></LazyWrapper>
  },
  // 导入教师 校务管理
  {
    path: 'school/:school/importTeacherUser',
    element: <LazyWrapper><ImportExcel></ImportExcel></LazyWrapper>
  },
  // 导入班级
  {
    path: 'school/:school/importClass',
    element: <LazyWrapper><ImportExcel></ImportExcel></LazyWrapper>
  },
  // 导入学生
  {
    path: 'school/:school/importStudentUser',
    element: <LazyWrapper><ImportExcel></ImportExcel></LazyWrapper>
  },
  {
    path: 'importHistory/:module',
    element: <LazyWrapper><ImportHistory></ImportHistory></LazyWrapper>
  },
  {
    path: 'importHistory/:module/detail',
    element: <LazyWrapper><ImportHistoryDetail></ImportHistoryDetail></LazyWrapper>
  },
  // 考试中心路由
  ...examCenterRouter,
  //权限路由
  ...permissionRouter
];

const frontRouterLayout: RouteObject[] = [
  {
    path: 'front',
    element: <Navigate to="/front/portal" />
  },
  {
    path: 'front',
    element: <FrontLayout />,
    children: [
      ...eduRouter,
      ...teacherRouter
    ]
  },
  {
    path: 'front/portal',
    element: <Portal></Portal>
  },
  ...analysisRouter,
  ...modifyRouter
];

export default frontRouterLayout;
